module.exports = __webpack_public_path__ + "img/yuanmingyuan big (8).b02ea314.jpg";